import { App } from '../../App';
import { getFetchHeaders } from '../../utils/fetchHeaders';
import { ioBlackBoxAtom } from '../../hooks/useIovation';
import { isValidApplication } from 'utils/applicationUtility';
import { useAtomValue } from 'jotai/index';
import { useEffect, useState } from 'react';
import { useGetClientApplication, usePutApplication } from '../../api';
import { useResolutionResolverPhoneVerification } from './useResolutionResolverPhoneVerification';
import { useSeon } from '../../hooks/useSeon';
import RegistrationLoading from '../RegistrationLoading/RegistrationLoading';
import useAffiliateInfo from '../../hooks/useAffiliateInfo';
import useClient from '../../hooks/useClient';
import useCrossDomainLoginRedirect from '../../hooks/useCrossDomainLoginRedirect';

export default function PhoneVerificationWaiting() {
  const { affiliateInfo } = useAffiliateInfo();
  const { sendSeonFraudInfo } = useSeon();
  const { client } = useClient();
  const ioBlackBox = useAtomValue(ioBlackBoxAtom);
  const [attempts, setAttempts] = useState(1);
  const { crossDomainLoginRedirect } = useCrossDomainLoginRedirect();

  const apiGetClientApplication = useGetClientApplication();
  const { fetch: fetchPutApplication } = usePutApplication();
  const apiAffiliateEventQualified = App.useApi(
    'affiliate-events/qualified',
    'POST',
  );
  const { fetch: fetchUpdateAffiliate } = App.useApi(
    'client/affiliate',
    'POST',
  );

  // useEffect to throw affiliates calls
  useEffect(() => {
    const affiliateCalls = async () => {
      try {
        try {
          await sendSeonFraudInfo();
        } catch {}

        if (affiliateInfo.provider) {
          await fetchUpdateAffiliate({
            body: affiliateInfo,
          });
        }

        if (client?.isRegisteredByAffiliate) {
          await apiAffiliateEventQualified.fetch({
            headers: getFetchHeaders(),
          });
        }
      } catch {}
    };
    affiliateCalls();
  }, [affiliateInfo.provider, client?.isRegisteredByAffiliate]);

  // useffect to confirm the application
  useEffect(() => {
    const confirmationCall = async () => {
      if (
        !apiGetClientApplication.data?.confirmed &&
        isValidApplication(apiGetClientApplication.data, client)
      ) {
        try {
          await fetchPutApplication({
            body: {
              ioBlackBox,
            },
          });
          await apiGetClientApplication.fetch();
        } catch {
          if (attempts > 3) {
            // Force re-login
            crossDomainLoginRedirect('dashboard', false);
          } else {
            setTimeout(() => setAttempts(attempts + 1), 1000);
          }
        }
      }
    };

    confirmationCall();
  }, [attempts, apiGetClientApplication.data?.confirmed, client]);

  useResolutionResolverPhoneVerification();

  return <RegistrationLoading />;
}
